/* JM Band – version 6: bevægelseslag.
   Blød scroll, intro i heroen og scroll-forløb, der binder sektionerne sammen:
   overskrifter afsløres ord for ord, kort og lister kommer i rytme, billeder driver (parallax),
   anmeldelserne glider med, og den grønne afslutning folder sig ud i fuld bredde.
   Slås helt fra ved prefers-reduced-motion og ?static=1; indholdet er synligt uden JS. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || /[?&]static=1/.test(location.search) || !window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const wide = matchMedia('(min-width: 761px)').matches;
  const ease = 'expo.out';
  document.documentElement.classList.add('has-motion');

  /* ---------- Blød scroll (kun mus/trackpad; touch beholder native scroll) ---------- */
  let lenis = null;
  if (fine && window.Lenis) {
    lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((t) => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);
    const drawer = $('#drawer');
    if (drawer) new MutationObserver(() => (drawer.hidden ? lenis.start() : lenis.stop())).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a || a.classList.contains('skip')) return;
      const id = a.getAttribute('href');
      const target = id.length > 1 && document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -90, duration: 1.2, force: true });
      history.replaceState(null, '', id);
    });
  }

  /* ---------- Hjælpere ---------- */
  function splitWords(el) {
    if (!el || el.dataset.split) return [];
    const words = [];
    const texts = [];
    const tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    while (tw.nextNode()) texts.push(tw.currentNode);
    texts.forEach((node) => {
      const frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        const w = document.createElement('span');
        const inner = document.createElement('span');
        w.className = 'w'; inner.textContent = part; w.appendChild(inner);
        frag.appendChild(w); words.push(inner);
      });
      node.replaceWith(frag);
    });
    el.dataset.split = '1';
    el.classList.add('split');
    return words;
  }
  // Grupper der kommer frem i rytme; transform/opacity ryddes bagefter, så CSS-hover virker igen.
  function rhythm(selector, { y = 40, stagger = 0.07, start = 'top 90%' } = {}) {
    const els = $$(selector);
    if (!els.length) return;
    gsap.set(els, { y, opacity: 0 });
    ScrollTrigger.batch(els, {
      start,
      once: true,
      onEnter: (batch) => gsap.to(batch, { y: 0, opacity: 1, duration: 1, ease, stagger, overwrite: true, clearProps: 'transform,opacity' }),
    });
  }

  /* ---------- Intro: heroen åbner ---------- */
  const heroWords = splitWords($('.hero h1'));
  gsap.timeline({ defaults: { ease, duration: 1.1 } })
    .from('.hero__media img', { scale: 1.06, duration: 1.8 }, 0) // Shopify D14: billedet vises med det samme (ingen fade), kun let zoom på plads
    .from('.usps li', { y: 10, opacity: 0, stagger: 0.06, duration: 0.8, clearProps: 'transform,opacity' }, 0.1)
    .from('.hero .eyebrow', { y: 14, opacity: 0, duration: 0.8 }, 0.15)
    .from(heroWords, { yPercent: 110, stagger: 0.035 }, 0.2)
    .from(['.hero__lead', '.hero__ctas', '.checks'], { y: 20, opacity: 0, stagger: 0.08, duration: 0.9, clearProps: 'transform,opacity' }, 0.55)
    .from('.finder', { y: 56, opacity: 0, duration: 1.1, clearProps: 'transform,opacity' }, 0.7)
    .from('.dk__item', { y: 26, opacity: 0, stagger: 0.05, duration: 0.8, clearProps: 'transform,opacity' }, 0.85);

  /* Progresslinjen i headeren styres af f26-app.js, så den virker på alle sider (punkt 16) */

  /* ---------- Overskrifter ord for ord ---------- */
  $$('.proof__h, .section h2').forEach((h) => {
    const words = splitWords(h);
    gsap.from(words, { yPercent: 110, duration: 1, ease, stagger: 0.03, scrollTrigger: { trigger: h, start: 'top 88%', once: true } });
  });
  $$('.section .eyebrow, .proof__kicker').forEach((el) => {
    gsap.from(el, { y: 12, opacity: 0, duration: 0.8, ease, clearProps: 'transform,opacity', scrollTrigger: { trigger: el, start: 'top 90%', once: true } });
  });

  /* ---------- Rytme i grupperne ---------- */
  rhythm('.proof__fg .lm, .proof__meta', { y: 20 });
  rhythm('.segment', { y: 70, stagger: 0.1 });
  rhythm('.card');
  rhythm('.about__copy > p, .pillars li, .about__copy > .link', { y: 24, stagger: 0.06 });
  rhythm('.reviews__nav, .reviews__note', { y: 16 });
  rhythm('.industries__copy > p:not(.eyebrow), .industries__copy > .btn', { y: 20 });
  rhythm('.industries__list li', { y: 18, stagger: 0.035 });
  rhythm('.story__copy > p:not(.eyebrow), .story__copy > .btn', { y: 24 });
  rhythm('.quote__top > p:not(.eyebrow), .quote__review, .quote__card, .qform', { y: 28, stagger: 0.07 });
  rhythm('.footer__grid > *', { y: 24, stagger: 0.06, start: 'top 96%' });

  /* ---------- Billeder med dybde: afsløring + parallax ---------- */
  $$('.story__media, .video').forEach((frame) => {
    gsap.fromTo(frame,
      { clipPath: 'inset(12% 8% 12% 8% round 14px)' },
      { clipPath: 'inset(0% 0% 0% 0% round 14px)', ease: 'none', scrollTrigger: { trigger: frame, start: 'top 95%', end: 'top 45%', scrub: true } });
  });
  if (wide) {
    $$('.story__media img').forEach((img) => {
      gsap.fromTo(img, { '--ps': 1.25, '--py': '-5%' }, { '--ps': 1.12, '--py': '5%', ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    $$('.segment').forEach((seg) => {
      gsap.fromTo(seg, { '--py': '-3.5%' }, { '--py': '3.5%', ease: 'none', scrollTrigger: { trigger: seg, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    gsap.to('.hero__media img', { yPercent: 7, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
    const tilt = $('.wall__tilt');
    if (tilt) gsap.fromTo(tilt, { y: -50 }, { y: 50, ease: 'none', scrollTrigger: { trigger: '.proof', start: 'top bottom', end: 'bottom top', scrub: true } });
  }

  /* ---------- Anmeldelser: uendelig række, roligt tempo med scrollen, kan trækkes ---------- */
  const revTrack = $('#reviews-track');
  if (revTrack) {
    const originals = [...revTrack.children];
    originals.forEach((card) => {
      const copy = card.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      revTrack.appendChild(copy);
    });
    document.documentElement.classList.add('reviews-loop');
    const viewport = revTrack.parentElement;
    const setX = gsap.quickSetter(revTrack, 'x', 'px');
    const drift = 280; // px rækken glider, mens sektionen passerer skærmen (samme tempo som før)
    let setW = 0, base = 0, scrollP = 0;
    const user = { x: 0 }; // brugerens træk/scroll sidelæns
    const measure = () => {
      const first = revTrack.children[0];
      setW = revTrack.children[originals.length].offsetLeft - first.offsetLeft;
      base = viewport.clientWidth / 2 - first.offsetWidth / 2; // første kort starter midt på skærmen
    };
    const render = () => { if (setW) setX(gsap.utils.wrap(-setW, 0, base - scrollP * drift + user.x)); };
    measure();
    ScrollTrigger.create({
      trigger: '.reviews', start: 'top bottom', end: 'bottom top',
      onRefresh: (st) => { measure(); scrollP = st.progress; render(); },
      onUpdate: (st) => { scrollP = st.progress; render(); },
    });
    // Træk med mus/finger (med lidt efterløb) og trackpad sidelæns
    let dragging = false, lastX = 0, lastT = 0, vel = 0;
    viewport.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      dragging = true; lastX = e.clientX; lastT = performance.now(); vel = 0;
      gsap.killTweensOf(user); viewport.setPointerCapture(e.pointerId); viewport.classList.add('is-dragging');
    });
    viewport.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const now = performance.now(), dx = e.clientX - lastX;
      vel = dx / Math.max(16, now - lastT); lastX = e.clientX; lastT = now;
      user.x += dx; render();
    });
    const release = () => {
      if (!dragging) return;
      dragging = false; viewport.classList.remove('is-dragging');
      gsap.to(user, { x: user.x + vel * 320, duration: 1.1, ease: 'power3.out', onUpdate: render });
    };
    viewport.addEventListener('pointerup', release);
    viewport.addEventListener('pointercancel', release);
    viewport.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // lodret scroll går videre til siden
      e.preventDefault(); gsap.killTweensOf(user); user.x -= e.deltaX; render();
    }, { passive: false });
    // Tastatur: piletaster flytter ét kort
    revTrack.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      const step = revTrack.children[1].offsetLeft - revTrack.children[0].offsetLeft;
      gsap.to(user, { x: user.x + (e.key === 'ArrowLeft' ? step : -step), duration: .6, ease: 'power3.out', onUpdate: render });
    });
  }

  /* ---------- Den grønne afslutning folder sig ud i fuld bredde og glider over i footeren ---------- */
  gsap.fromTo('.quote',
    { clipPath: 'inset(0% 4% 0% 4% round 28px)' },
    { clipPath: 'inset(0% 0% 0% 0% round 0px)', ease: 'none', scrollTrigger: { trigger: '.quote', start: 'top bottom', end: 'top 20%', scrub: true } });

  addEventListener('load', () => ScrollTrigger.refresh());
})();
